import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { RadioButton } from 'components/UI/RadioButton/RadioButton';
import { AccordionCollapsible } from '../DeliveryMethodsAccordion/AccordionCollapsible';
import { DeliveryMethodsFaqModal } from './DeliveryMethodsFaqModal';

export const DeliveryMethodETicket = (props) => {
  const {
    DeliveryMethodId,
    DeliveryMethodDisplayName,
    DeliveryMethodFeeDescription,
    DeliveryMethodDescription,
    faqsForETPopUp,
    showMoreTextET,
    selectedDeliveryMethodId,
    handleRadioButtonChange,
  } = props;

  const isChecked = selectedDeliveryMethodId === DeliveryMethodId;
  const [isOpen, setIsOpen] = useState(true);
  const faqModalProps = {
    faqs: faqsForETPopUp.FAQS,
    modalTitle: faqsForETPopUp.Title,
    showMoreText: showMoreTextET,
    readMoreText: 'Read the eTickets FAQs',
  };

  useEffect(() => {
    if (selectedDeliveryMethodId !== null && selectedDeliveryMethodId !== 0) {
      setIsOpen(isChecked);
    }
  }, [selectedDeliveryMethodId]);

  return (
    <>
      <RadioButton
        highlightLabel="Recommended"
        id={`delivery-option-${DeliveryMethodId}`}
        label={DeliveryMethodDisplayName}
        name="deliveryOptions"
        onChangeHandler={() => handleRadioButtonChange(DeliveryMethodId)}
        smallLabelText={DeliveryMethodFeeDescription}
        value={DeliveryMethodId}
        isChecked={isChecked}
        key={DeliveryMethodId}
        extendClass="panel"
      >
        <AccordionCollapsible id={`collapse-${DeliveryMethodId}`} isActive={isOpen}>
          <div className="delivery-info">
            <small>
              {DeliveryMethodDescription}
              <DeliveryMethodsFaqModal {...faqModalProps} />
            </small>
          </div>
        </AccordionCollapsible>
      </RadioButton>
      <hr />
    </>
  );
};

DeliveryMethodETicket.propTypes = {
  DeliveryMethodId: PropTypes.number,
  DeliveryMethodDisplayName: PropTypes.string,
  DeliveryMethodFeeDescription: PropTypes.string,
  DeliveryMethodDescription: PropTypes.string,
  faqsForETPopUp: PropTypes.object,
  showMoreTextET: PropTypes.string,
  selectedDeliveryMethodId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleRadioButtonChange: PropTypes.func,
};
